// ============================================================================
// WizardContainer Component (Outer Wrapper with Provider)
// ============================================================================

import { Dialog } from "@mui/material";
import { WizardProvider } from "../WizardContext";
import type { WizardContainerProps } from "../WizardContainer.types";
import { WizardContainerInner } from "./WizardContainerInner";

/**
 * Main container component that provides context and wraps the wizard in a dialog.
 * When renderWithoutDialog is true, renders only the provider and inner content
 * (for embedding in a parent modal).
 */
export function WizardContainer({
	initialGeoData,
	initialJobs,
	onComplete,
	onCancel,
	company,
	allDeals,
	salespersons,
	branches,
	selectedBranch,
	growers,
	user,
	lastCropOptions,
	nextCropOptions,
	renderWithoutDialog = false,
	onStartOver,
}: WizardContainerProps) {
	const formContext = {
		company,
		allDeals,
		salespersons,
		branches,
		growers,
		user,
		lastCropOptions,
		nextCropOptions,
	};

	const innerContent = (
		<WizardProvider initialGeoData={initialGeoData} initialJobs={initialJobs} formContext={formContext}>
			<WizardContainerInner
				onComplete={onComplete}
				onCancel={onCancel}
				onStartOver={onStartOver}
				company={company}
				allDeals={allDeals}
				salespersons={salespersons}
				branches={branches}
				selectedBranch={selectedBranch}
				growers={growers}
				user={user}
			/>
		</WizardProvider>
	);

	// When renderWithoutDialog is true, render content directly (parent provides Dialog)
	if (renderWithoutDialog) {
		return innerContent;
	}

	// Default: wrap in Dialog for backward compatibility
	return (
		<Dialog open={true} onClose={onCancel} maxWidth="lg" fullWidth>
			{innerContent}
		</Dialog>
	);
}
